"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOps = void 0;
const OpModel_1 = __importDefault(require("@opsbase/lib-data-model/models/OpModel"));
const GQLQueryArrayHook_1 = __importDefault(require("@opsbase/react-gql/GQLQueryArrayHook"));
const GQLResponseType_1 = __importDefault(require("@opsbase/react-gql/GQLResponseType"));
const standardCollectionParams_1 = __importDefault(require("@opsbase/react-gql/helpers/standardCollectionParams"));
const OpsConfig = {
    model: OpModel_1.default,
    name: 'opsElastic',
    response: GQLResponseType_1.default.COLLECTION,
    params: Object.assign(Object.assign({}, standardCollectionParams_1.default), { opStatus: '[String]', opDefinition: '[String]', place: '[String]', team: '[String]', staff: '[String]', position: '[String]', score: '[String]', startFrom: '[ISODate]', completeBy: '[ISODate]', actualStart: '[ISODate]', actualComplete: '[ISODate]' }),
};
exports.useOps = (0, GQLQueryArrayHook_1.default)(OpsConfig);
exports.default = exports.useOps;
